import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import schedulePageActions from 'store/schedule/schedulePageActions';
import { SCHEDULE_DAY_VIEWS, SCHEDULE_VIEW_TYPES } from 'pages/ScheduleV6/constants/constants';


const useScheduleViewSync = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const scheduleView = useSelector((state) => state.schedule.scheduleView);
  const scheduleDayView = useSelector((state) => state.schedule.scheduleDayView);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const viewParam = params.get('view');
    const typeParam = params.get('type');
    const view = SCHEDULE_VIEW_TYPES[viewParam] ? viewParam : scheduleView;

    if (view !== scheduleView) dispatch(schedulePageActions.setScheduleView(view));
    if (typeParam && view === SCHEDULE_VIEW_TYPES.daily && SCHEDULE_DAY_VIEWS[typeParam]) {
      dispatch(schedulePageActions.setScheduleDayView(typeParam));
    }
  }, []);


  // Re-applies view/type after any navigation (date change, ?sheetId= links) that drops them.
  useEffect(() => {
    const next = new URLSearchParams(location.search);
    next.set('view', scheduleView);
    if (scheduleView === SCHEDULE_VIEW_TYPES.daily) {
      next.set('type', scheduleDayView);
    } else {
      next.delete('type');
    }

    const query = `?${next.toString()}`;
    if (query !== location.search) navigate(`${location.pathname}${query}`, { replace: true });
  }, [scheduleView, scheduleDayView, location.pathname, location.search, navigate]);
};

export default useScheduleViewSync;
